<div class="modal-header mb-3">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="breeding-method.title"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm" class="form-horizontal">
        <div class="mb-3 row">
            <label for="breedingMethodName" class="col-sm-4 col-form-label text-start" jhiTranslate="breeding-method.field.breeding.method.name">Breeding Method Name</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="breedingMethodName" [(ngModel)]="breedingMethod.name" jhi-forbiddenCharactersValidator [disabled]="!editable"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="breedingMethodCode" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-method.field.code">Code</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="breedingMethodCode" [(ngModel)]="breedingMethod.code" jhi-forbiddenCharactersValidator [disabled]="!editable"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-method.field.description">Description</label>
            <div class="col-sm-8">
                <textarea class="form-control" rows="3" name="description" [(ngModel)]="breedingMethod.description" jhi-forbiddenCharactersValidator [disabled]="!editable"></textarea>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="type" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-method.field.generation.advancement.type">Generation Advancement Type</label>
            <div class="col-sm-8">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="type" [value]="selectedBreedingMethodType?.name" disabled/>
                <select *ngIf="editable" class="form-select col-sm-6" name="type" [(ngModel)]="breedingMethod.type" readonly>
                    <option *ngFor="let breedingMethodType of breedingMethodTypes" [value]="breedingMethodType.code">
                        <label>{{breedingMethodType.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="system" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-method.field.crop.reproductive.system">Crop Reproductive System</label>
            <div class="col-sm-8">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="system" [value]="selectedBreedingMethodGroup?.name" disabled/>
                <select *ngIf="editable" class="form-select col-sm-6" name="system" [(ngModel)]="breedingMethod.group" readonly>
                    <option *ngFor="let breedingMethodGroup of breedingMethodGroups" [value]="breedingMethodGroup.code">
                        <label>{{breedingMethodGroup.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="class" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-method.field.class" readonly>Class</label>
            <div class="col-sm-8">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="class" [value]="selectedBreedingMethodClass?.name" disabled/>
                <select *ngIf="editable" class="form-select col-sm-6" name="class" [(ngModel)]="breedingMethod.methodClass" readonly>
                    <option *ngFor="let breedingMethodClass of breedingMethodClasses" [value]="breedingMethodClass.id">
                        <label>{{breedingMethodClass.name}}</label>
                    </option>
                </select>
            </div>
        </div>
    </form>
</div>
